import { render } from "./TableExtracao.vue?vue&type=template&id=605369f8&scoped=true"
import script from "./TableExtracao.vue?vue&type=script&lang=js"
export * from "./TableExtracao.vue?vue&type=script&lang=js"

import "./TableExtracao.vue?vue&type=style&index=0&id=605369f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605369f8"]])

export default __exports__